module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Closed.282a720e.png";